// extracted by mini-css-extract-plugin
export default {"text":"ProjectGroupStats-module__text___CYfR3","overBudget":"ProjectGroupStats-module__overBudget___SAfrH"};